import { TransactionProperty } from '@/features/InvoiceReport/Edit/type';
import { InvoiceTransactionDefaultColumn } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/Table/Columns/columns';
import { InvoiceTransactionColumn } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/hooks/useInvoiceTransactionColumns';

export const getDefaultColumnProps = (
  defaultColumns: InvoiceTransactionDefaultColumn[],
  masterFieldName: string | undefined
): InvoiceTransactionDefaultColumn | undefined =>
  masterFieldName
    ? defaultColumns.find((item) => item.masterFieldName === masterFieldName)
    : undefined;

export const getDynamicColumnProps = (
  defaultColumns: InvoiceTransactionDefaultColumn[],
  dynamicColumnProps: TransactionProperty
): InvoiceTransactionColumn | undefined => {
  const title = dynamicColumnProps.label;
  const key = dynamicColumnProps.id;
  const width = dynamicColumnProps.columnWidth
    ? `${dynamicColumnProps.columnWidth}px`
    : undefined;

  const masterFieldName = dynamicColumnProps.masterFieldName;
  const defaultProps = getDefaultColumnProps(defaultColumns, masterFieldName);

  if (defaultProps) {
    const align = defaultProps.align;
    const dataIndex = defaultProps.dataIndex;
    const render = defaultProps.render;

    return {
      title,
      dataIndex,
      render,
      width,
      key,
      align,
    };
  } else {
    // TODO(APWARRIOR-1753): Implement displaying custom columns
    return undefined;
  }
};
